import React from 'react';
import { Text } from '../../components/Text';

const EmptyMessageState = ({ component }) => {
  return (
    <div
      className="flex flex-column align-items-center justify-content-center h-full text-center"
      style={{ minHeight: '250px', color: '#8a8a8a' }}
    >
      {component === 'telegram' ? (
        <i className="pi pi-send mb-3" style={{ fontSize: '42px', opacity: 0.6 }} />
      ) : (
        <i className="pi pi-whatsapp mb-3" style={{ fontSize: '42px', opacity: 0.6 }} />
      )}

      <Text type="heading">No messages yet</Text>

      <Text type="sub-heading" cust="mt-1">
        Send a message to start the conversation
      </Text>
    </div>
  );
};

export default EmptyMessageState;
